<h2 mat-dialog-title>Partitionnement de Colis</h2>
<div style="padding: 0 24px; overflow: hidden;">
  <div style="margin-top: 10px;">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>{{ 'partition' | translate }}</mat-label>
      <input
        matInput
        type="number"
        placeholder="{{ 'partition' | translate }}"
        min="0"
        id="{{ data.idcollis }}"
        (input)="getpartitionid(data, $event.target.value)"
        value="{{ data.quantitereste }}"
        max="{{ data.quantitereste }}"
      />
      <mat-hint>Max: {{ data.quantitereste }}</mat-hint>
    </mat-form-field>
  </div>

  <ng-container *ngIf="multipleColis">
    <div class="table-container mat-elevation-z2" style="max-height: 300px; overflow: auto; margin-bottom: 20px;">
      <table mat-table [dataSource]="dataSource" style="width: 100%;">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef style="width: 60px;">
            <mat-checkbox
              color="primary"
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              color="primary"
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Position Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="width: 60px;">No.</th>
          <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>{{ "nomcollis" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ element }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="selection.toggle(row)"
          style="cursor: pointer;"
        ></tr>
      </table>
    </div>
  </ng-container>
</div>

<mat-dialog-actions align="end" style="padding-bottom: 20px; padding-right: 20px;">
  <button mat-button (click)="close()">
    {{ "buttons.cancel" | translate }}
  </button>
  <button mat-raised-button color="primary" cdkFocusInitial (click)="save()">
    {{ "Partitioner" | translate }}
  </button>
</mat-dialog-actions>
